import { Button, Layout, PageHeader, Result } from 'antd'
import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import DataTable from '~/components/dataTable'
import { getColumns } from '../columns'

import { editTitle, listItems } from '~/states/modules/databaseDetail'

import BreadCrumb from 'components/breadCrumb'
import CreationModal from 'components/creationModal/modal'
import PropTypes from 'prop-types'
import { deleteItem } from 'states/modules/databaseDetail'
import ListItemDocuments from '~/components/modalListDocuments'

const TextDatabaseItemsListing = ({
	onReturnParent,
	onCreateText,
	onEditText,
	idDataBase,
}) => {
	const dispatch = useDispatch()
	const { database, items } = useSelector(
		({ databaseDetail }) => databaseDetail
	)

	const [showModal, setShowModal] = useState(false)
	const [showDocumentModal, setShowDocumentModal] = useState(false)
	const [selectedItem, setSelectedItem] = useState('')
	const [modalTitle, setModalTile] = useState('')

	const handleShowModal = () => setShowModal(true)
	const handleCancel = () => setShowModal(false)
	const handleCreate = (title) => {
		setShowModal(false)
		onCreateText(title)
	}

	const handleEditTitleButton = (title) => dispatch(editTitle({ title }))

	const handleDeleteItem = (row) => dispatch(deleteItem({ id: row.id }))

	const handleModalListDocuments = (row) => {
		setModalTile(row.description)
		setSelectedItem(row.key.toString())
		setShowDocumentModal(true)
	}

	const handleCancelDocumentModal = () => {
		setShowDocumentModal(false)
	}

	const handlePaginationAndSearch = ({ page, perPage, search }) => {
		dispatch(listItems({ id: idDataBase, page, perPage, search }))
	}

	return (
		<>
			<PageHeader>
				<BreadCrumb
					parent="Bancos de textos"
					editable={true}
					current={database.title}
					onEdit={handleEditTitleButton}
					onClickParent={onReturnParent}
				/>
			</PageHeader>
			<Layout style={{ backgroundColor: '#fff' }}>
				<CreationModal
					title="Novo texto"
					label="Título"
					handleCancel={handleCancel}
					handleCreate={handleCreate}
					showModal={showModal}
				/>
				<ListItemDocuments
					visible={showDocumentModal}
					onCancel={handleCancelDocumentModal}
					idDataBase={idDataBase}
					selectedItem={selectedItem}
					type="text_database"
					modalTitle={modalTitle}
				/>
				<DataTable
					columns={getColumns(
						onEditText,
						handleDeleteItem,
						handleModalListDocuments
					)}
					dataSource={items.data}
					pages={items.pages}
					onChangePageNumber={handlePaginationAndSearch}
					onSearch={handlePaginationAndSearch}
					onClickButton={handleShowModal}
					textButton="Novo Texto"
					placeholderNoData={
						!items.loading ? (
							<Result
								icon={<></>}
								title={
									<p style={{ color: 'gray' }}>
										Ainda não há textos nesse banco
									</p>
								}
								extra={
									<Button type="primary" onClick={handleShowModal}>
										Novo Texto
									</Button>
								}
								style={{ paddingTop: 0 }}
							/>
						) : (
							''
						)
					}
					loading={items.loading}
				/>
			</Layout>
		</>
	)
}

TextDatabaseItemsListing.propTypes = {
	onReturnParent: PropTypes.func,
	onCreateText: PropTypes.func,
	onEditText: PropTypes.func,
	idDataBase: PropTypes.string,
}

export default TextDatabaseItemsListing
